<table class="selectableTable">
  <tr>
    <th>Guest</th>
    <th>Support</th>
    <th>Joined</th>
    <th></th>
  </tr>
  @for (
    item of this.dataSource.data;
    track item.id;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.id != undefined) {
      <tr
        id="trsummary_{{ item.id }}"
        class="rowSummary highlightable"
        [ngClass]="{ even: even, odd: odd }"
        (click)="_selectRow_click(item.id)"
      >
        <td style="width: 27%">{{ item.guestName }}</td>
        <td style="width: 27%">{{ item.supportName }}</td>
        <td style="width: 27%">{{ item.joined }}</td>
        <td style="width: 8%">
          <button
            aria-label="Manage"
            title="Manage customer"
            (click)="selectRow_click(item.id)"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </td>
      </tr>
    }
    @if (this.options.selectAction == 'expand') {
      <tr
        id="trdetails_{{ item.id }}"
        class="rowDetails noHover"
        style="display: none"
      >
        <td colspan="5">
          <div>
            <b>Customer Details</b>
          </div>
        </td>
      </tr>
    }
  }
</table>
